import { css } from '@emotion/css';
import { createSignal } from 'solid-js';
import { Popup } from 'Shared/forms/Popup';
import { theme } from 'Shared/ThemeProvider';
import { selectStyle } from 'Shared/forms/Inputs';


export function CopyItemPopup(P: {
	title: string,
	selectLabel: string,
	count: number,
	close: () => void,
	onCopy: (index: number) => void,
})
{
	const formStyle = css({
		display: 'flex',
		flexDirection: 'column',
		gap: '1em',
		minWidth: '14em',
	});

	const fieldStyle = css({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: '0.6em',
	});

	const actionStyle = css({
		display: 'flex',
		gap: '0.5em',
		justifyContent: 'flex-end',
	});


	const buttonStyle = () => css(theme().button);
	const [copyFrom, setCopyFrom] = createSignal(0);

	return (
		<Popup title={P.title} close={P.close}>
			<div class={formStyle}>
				<div class={fieldStyle}>
					<label>{P.selectLabel}</label>
					<select class={selectStyle()}
						value={copyFrom() + 1}
						onChange={e => setCopyFrom(Number(e.currentTarget.value) - 1)}
					>
						{Array.from({length: P.count}, (_, i) => (
							<option value={i + 1}>{i + 1}</option>
						))}
					</select>
				</div>
				<div class={actionStyle}>
					<button class={buttonStyle()} onClick={() => P.onCopy(copyFrom())}>Copy</button>
					<button class={buttonStyle()} onClick={P.close}>Cancel</button>
				</div>
			</div>
		</Popup>
	);
}
